import { Grid } from '@mui/material';
import EmployeeCommutingDataCapturing from './EmployeeCommutingDataCapturing';

export default function EmployeeCommuting({ year, groupId }) {

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <EmployeeCommutingDataCapturing year={year} groupId={groupId} />
            </Grid>
        </Grid>
    );
}

/*
Select Category 1->Select Petrol->Select Petrol (mobile) ->
Select month ->Select asset from drop down list->
Select unit from drop down list (rand or Litres)->
Manually Enter petrol mobile consumption for the selected asset in the selected month with the corresponding unit->
Upload corresponding source documentation

Users should be able to see the annual sum table for corresponding line items in the TOTALS tab (i.e. 12 month total).

*/
